export default "__VITE_ASSET__46bae277__"